<app-main-header [breadcrumbs]="breadcrumbs"></app-main-header>

<lib-billing-popup-terminal
  [terminalVid]="terminalVid"
  *ngIf="environment.showBillingPopup && sessionLib.getUserHasNonDemoTerminals() === 'true'"
></lib-billing-popup-terminal>

<ion-content>
  <div
    *ngIf="
      !terminalData &&
        !weather &&
        !equipmentResponse &&
        !programsResponse &&
        !fertilizerFormulasResponse;
      else notLoading
    "
  >
    <div class="d-flex mt-4 justify-content-center align-items-center h-75">
      <div class="spinner-border text-warning" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

  <ng-template #notLoading>
    <div class="container-fluid my-4" *ngIf="equipmentResponse">
      <div class="mb-4">
        <app-equipment-data
          type="configurable"
          [terminal_vid]="terminalVid"
          [equipmentResponse]="equipmentResponse"
        ></app-equipment-data>
      </div>

      <app-meteo-grid
        [meteoRows]="meteoRows"
        [terminalType]="'configurable'"
      ></app-meteo-grid>

      <app-configurable-water-system
        [equipment]="equipmentResponse"
        [class]="'mb-4'"
      >
      </app-configurable-water-system>

      <app-configurable-states
        [equipment]="equipmentResponse"
        [terminal]="terminalData"
      ></app-configurable-states>

      <app-alarms-grid
        *ngIf="equipmentResponse"
        [equipmentResponse]="equipmentResponse"
        [alarmRows]="alarmRows"
        [type]="'configurable'"
      ></app-alarms-grid>

      <mat-tab-group
        [ngModel]="selectedTab"
        [selectedIndex]="selectedTab"
        class="my-4 tab-container"
        matTabGroupGesture
        [swipeLimitWidth]="80"
        [connectEdges]="true"
      >
        <mat-tab label="{{ 'irrigation_programs' | translation }}">
          <div class="mt-4"></div>
          <app-terminal-table-wrapper
            [data]="programsResponse"
            [states]="equipmentResponse.states"
            [name]="'configurable_programs'"
            [fertilizerFormulas]="fertilizerFormulasResponse"
            [searchPlaceholder]="'configurable_name' | translation"
            [isFetchingData]="isTableLoading"
            [terminal_vid]="terminalVid"
            [tableHeaders]="[
              'configurable_status' | translation,
              'configurable_name' | translation,
              ('configurable_program_week' | translation) +
                ' • ' +
                ('configurable_program_start_time' | translation) +
                ' • ' +
                ('configurable_program_end_time' | translation),

              'configurable_time' | translation
            ]"
            type="configurable"
          >
            <tr
              class="row-pointer"
              *appTerminalTableData="let prog"
              [routerLink]="[
                '/farming',
                terminalVid,
                'configurable',
                'program',
                prog.program,
                'group',
                0
              ]"
            >
              <td
                class="terminal-table-data"
                *ngIf="prog.states; else notStates"
              >
                <span
                  class="badge"
                  [ngClass]="{
                    'bg-secondary': prog.active === false,
                    'bg-success': prog.active === true
                  }"
                  >{{
                    prog.active
                      ? ('irrigation_program_active' | translation)
                      : ('irrigation_program_inactive' | translation)
                  }}</span
                >
                &nbsp;
                <span
                  [class]="prog.states[0].state | badgeClass : 'CONFIGURABLE'"
                  >{{
                    'irrigation_state_' + prog.states[0].state
                      | lowercase
                      | translation
                  }}</span
                >
              </td>
              <ng-template #notStates>
                <td #notStates class="terminal-table-data">
                  <span
                    class="badge"
                    [ngClass]="{
                      'bg-secondary': prog.active === false,
                      'bg-success': prog.active === true
                    }"
                    >{{
                      prog.active
                        ? ('irrigation_program_active' | translation)
                        : ('irrigation_program_inactive' | translation)
                    }}</span
                  >
                </td>
              </ng-template>
              <td class="terminal-table-data">
                {{ prog.name }}
              </td>
              <td class="terminal-table-data">
                {{ prog | convertWeekDays }} •
                {{ prog.startTime * 1000 | date : 'HH:mm:ss' : 'UTC' }} •
                {{ prog.endTime * 1000 | date : 'HH:mm:ss' : 'UTC' }}
              </td>
              <td class="terminal-table-data">
                {{
                  getProgramState(prog.program)?.actualTime * 1000
                    | date : 'HH:mm:ss' : 'UTC'
                }}
                /
                {{
                  getProgramState(prog.program)?.todayTime * 1000
                    | date : 'HH:mm:ss' : 'UTC'
                }}
              </td>
            </tr>
          </app-terminal-table-wrapper>
        </mat-tab>
        <mat-tab
          label="{{ 'remote_control' | translation }}"
          *ngIf="terminalData.authed_user_can_admin"
        >
          <div class="mt-4 container-fluid">
            <div class="row">
              <div class="col-12 col-md-6 order-1 order-md-2">
                <div class="card configurable-card-border mb-3 mb-md-2">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        {{
                          'remote_control_description'
                            | translation
                            | sanitizeText
                        }}
                      </div>

                      <div class="col-12 d-none d-md-block">
                        <h6 class="fs-2">
                          {{ 'remote_control_queue' | translation }}
                        </h6>
                        <div class="queued-buttons-container">
                          <div class="queued-buttons-content">
                            <div
                              class="queued-button"
                              *ngFor="let queued of buttonQueue"
                            >
                              <img [src]="queued.src" [alt]="queued.label" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 d-none d-md-block">
                        <h6 class="fs-2">
                          {{ 'remote_control_last_sended' | translation }}
                        </h6>
                        <div class="last-sended-button-container">
                          <div
                            class="last-sended-button"
                            *ngIf="lastSendedButton"
                          >
                            <img
                              [src]="lastSendedButton.src"
                              [alt]="lastSendedButton.label"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 order-2 order-md-1">
                <div class="card configurable-card-border mb-3 mb-md-2">
                  <div class="card-body">
                    <app-remote-control
                      class="p-0"
                      [terminal_vid]="terminalVid"
                      [terminal_connected]="equipmentResponse.connected"
                      (buttonQueue)="onButtonQueue($event)"
                      (lastSendedButton)="onLastSendedButton($event)"
                    ></app-remote-control>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div
      class="container-fluid my-4"
      *ngIf="
        terminalData && terminalEnabled === TERMINAL_ENABLED_TEMPORARY_DISABLED
      "
    >
      <app-equipment-temporary-disabled-data
        [terminalData]="terminalData"
        [type]="'configurable'"
      ></app-equipment-temporary-disabled-data>

      <app-terminal-placeholder-data
        [terminalType]="'configurable'"
      ></app-terminal-placeholder-data>
    </div>
  </ng-template>
</ion-content>
